var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlidePicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 39,
    viewBox: "0 0 77 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 75,
    height: 37,
    rx: 8,
    fill: "#AA1070",
    stroke: "#F8EBFD",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 73,
    height: 34,
    rx: 8,
    fill: "#CD3F97"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 2,
    width: 1,
    height: 35,
    rx: 0.5,
    fill: "#ED75C0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 2,
    width: 1,
    height: 35,
    rx: 0.5,
    fill: "#AA1070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidePicker);
export default __webpack_public_path__ + "static/media/slide-picker.d413327e49441e29e9a3c9a183c9511b.svg";
export { ForwardRef as ReactComponent };